import React from 'react';

function LoaderItem (props) {
  return (
    <div className='marker-waiting-overlay'>
      <div className='radial-progress'>
        <div className='circle'>
          <div className='fill' />
        </div>
      </div>
    </div>
  );
}

export default LoaderItem;



// WEBPACK FOOTER //
// ./src/ui/Maps/Controls/Popup/LoaderItem.jsx